import { RequirementSampleMaturityAssignmentParams } from '@/backend/access/requirementSampleMaturityAssignment/types';

export class RequirementSampleMaturityAssignment {
  id: string;
  createdAt?: Date | string;
  updatedAt?: Date | string;
  requirementId: string;
  sampleMaturityId: string;

  constructor(params: RequirementSampleMaturityAssignmentParams) {
    this.id = params.id;
    this.createdAt = params.createdAt;
    this.updatedAt = params.updatedAt;
    this.requirementId = params.requirementId;
    this.sampleMaturityId = params.sampleMaturityId;
  }
}
